export default "__VITE_ASSET__ClYkdeDv__"